<div class="custom-form">
  <div class="col-12 offset-1">
    <div *ngIf="AttachmentArr[0]!=undefined">
      <table class="table table-striped mt-1">
        <thead class="thead-dark">
          <tr>
            <th>{{ "AttachmentType" | translate }}</th>
            <th>{{ "addedToIndex" | translate }}</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of AttachmentArr">
            <td>{{ item.attachmentType.attachmentTypeName }}</td>
            <td>
              <p *ngIf="item.isAddedToIndex">نعم</p>
              <p *ngIf="!item.isAddedToIndex">لا</p>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="AttachmentArr[0]==undefined">
      <h5 style="text-align: center;">{{"NotFoundAttachment" | translate}}</h5>
    </div>
  </div>
</div>